import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const EditNew16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.2333 1.00006C12.5972 0.9976 12.9579 1.06725 13.2946 1.20498C13.6314 1.34271 13.9375 1.5458 14.1953 1.80251L14.1973 1.80451C14.4541 2.06225 14.6573 2.36834 14.7951 2.70508C14.9329 3.04182 15.0026 3.40254 15.0001 3.76637C14.9977 4.13021 14.9231 4.48995 14.7808 4.8248C14.639 5.15823 14.4328 5.4604 14.1741 5.71397L6.08812 13.7999C5.99637 13.8917 5.88166 13.9571 5.75598 13.9893L1.90406 14.9773C1.65616 15.0409 1.39312 14.9689 1.21215 14.7879C1.03117 14.607 0.959149 14.3439 1.02269 14.096L2.01008 10.2441C2.04231 10.1184 2.10773 10.0037 2.1995 9.91188L10.2856 1.8258C10.5392 1.56712 10.8415 1.36102 11.175 1.21933C11.5098 1.07705 11.8695 1.00253 12.2333 1.00006ZM12.7463 2.54546C12.5867 2.48016 12.4157 2.44714 12.2432 2.4483C12.0707 2.44947 11.9001 2.48481 11.7413 2.55227C11.5826 2.61973 11.4387 2.71798 11.3181 2.84134L11.3124 2.84725L3.36377 10.7958L2.72942 13.2704L5.20418 12.6357L13.1588 4.68108C13.2822 4.56059 13.3805 4.41688 13.4479 4.25819C13.5154 4.09949 13.5507 3.929 13.5519 3.75657C13.5531 3.58413 13.52 3.41318 13.4547 3.25359C13.3896 3.09442 13.2936 2.94971 13.1724 2.82777C13.0504 2.70653 12.9056 2.61059 12.7463 2.54546Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
